var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255.1 255.1",
    style: {
      enableBackground: "new 0 0 255.1 255.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C8B686;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 127.6,
    cy: 127.6,
    r: 121.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.599,124.04c-0.01-0.013-0.014-0.03-0.011-0.046l10.762-62.756c0.005-0.029,0.03-0.05,0.059-0.05h3.406 c0.026,0,0.049,0.017,0.057,0.042l24.247,76.771c0.008,0.024-0.001,0.05-0.02,0.066l-17.878,13.958 c-0.027,0.021-0.065,0.015-0.085-0.012L173.599,124.04z M43.077,165.643c0,0.026,0.017,0.049,0.041,0.057l36.853,12.05 c0.018,0.006,0.038,0.003,0.053-0.008l82.374-56.869c0.014-0.01,0.023-0.024,0.025-0.041l8.834-59.272 c0.006-0.036-0.023-0.069-0.059-0.069H98.235c-0.018,0-0.035,0.008-0.046,0.022L43.091,127.98c-0.009,0.011-0.014,0.024-0.014,0.039 V165.643z M95.328,180.82l40.261,13.188c0.018,0.006,0.038,0.003,0.054-0.008l47.933-34.383c0.027-0.019,0.033-0.055,0.015-0.082 l-17.969-26.739c-0.019-0.028-0.056-0.035-0.084-0.016L95.328,180.82z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRock);
export default __webpack_public_path__ + "static/media/rock.cbe1ed87e6a81884a2267e26873ed1e8.svg";
export { ForwardRef as ReactComponent };